import { TopicRecord } from '@playbook/data-models/records/topic-record';

export class TopicTemplateRecord extends TopicRecord {
}
